import React from "react";
import { Helmet } from 'react-helmet';
import axios from 'axios';
import Header from "../Header";
import Footer from "../Footer";
import AppContext from '../AppContext';

const getJobId = (job, index) => job?._id || job?.id || index;
const slugify = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
const getJobSlug = (job, index) => {
    const titleSlug = slugify(job?.job || job?.title || 'career-opening');
    return `${titleSlug}-${getJobId(job, index)}`;
};

class Career extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            jobs: [],
            loading: true,
            error: '',
        };
    }

    componentDidMount() {
        const contextJobs = this.context?.apiCareerData;

        if (Array.isArray(contextJobs)) {
            this.setState({
                jobs: contextJobs,
                loading: false,
            });
            return;
        }

        axios.get("/careers")
            .then((response) => {
                this.setState({
                    jobs: Array.isArray(response.data) ? response.data : [],
                    loading: false,
                });
            })
            .catch((error) => {
                console.error("Career API Error:", error);
                this.setState({
                    error: "We could not load current openings right now. Please try again later.",
                    loading: false,
                });
            });
    }

    onClickShowdetails(job, index) {
        localStorage.setItem("Job", JSON.stringify(job));
        window.location.href = `/career/${getJobSlug(job, index)}`;
    }

    renderJobs() {
        const { jobs, loading, error } = this.state;

        if (loading) {
            return <div className="col-12"><h4>Loading open positions...</h4></div>;
        }

        if (error) {
            return <div className="col-12"><h4 style={{ color: "Red", fontSize: "20px" }}>{error}</h4></div>;
        }

        if (!jobs.length) {
            return <div className="col-12"><h4 style={{ color: "Red", fontSize: "20px" }}>No current openings found.</h4></div>;
        }

        return jobs.map((job, index) => (
            <div className="experience-box" key={getJobId(job, index)}>
                <span className="experience-box_num">{job.position > 1 ? `${job.position - 1}+` : (job.position || 1)}</span>
                <h6 className="experience-box_title">{job.job || job.title || "Career Opening"}</h6>
                <p className="experience-box_text">Location - {job.job_location || job.location || "Surat, Gujarat"}</p>
                <a href={`/career/${getJobSlug(job, index)}`} onClick={(event) => {
                    event.preventDefault();
                    this.onClickShowdetails(job, index);
                }}>View Details</a>
            </div>
        ));
    }

    render() {
        const myStyleone = {
            background: "#1f1f22",
            width: "100%",
            zIndex: 2,
        };

        return (
            <>
                <Helmet>
                    <title>Careers at Oengines | Open Positions</title>
                    <meta
                        name="description"
                        content="Explore current career openings at Oengines for game development, mobile app development, web development, design, QA, and product support roles."
                    />
                    <link rel="canonical" href="https://www.oengines.com/career" />
                    <script src="../assets/js/script.js" type="text/Javascript"></script>
                </Helmet>
                <Header />
                <div className="breadcumb-wrapper" style={myStyleone}>
                    <div className="container">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title">Shine bright with us</h1>
                            <ul className="breadcumb-menu">
                                <li>Join a team building games, apps, web platforms, UI/UX, backend systems, QA workflows, and live product support.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <section className="space">
                    <div className="container">
                        <div className="row gy-4 spc_career">
                            <div className="experience-box-wrap">
                                {this.renderJobs()}
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup" data-top="0%" data-right="0%"><img src="assets/img/shape/tech_shape_1.png"
                        alt="shape" /></div>
                    <div className="shape-mockup" data-bottom="0%" data-left="0%" style={{ left: "0" }}><img src="assets/img/shape/tech_shape_2.png"
                        alt="shape" /></div>
                </section>
                <Footer apiCareerData={this.state.jobs} />
            </>
        )
    }
}

export default Career;
